import React, { Component } from 'react';

import CalcSlider from '../CalcSlider/CalcSlider';

import '../Form/Form.scss';
import './CalculateForm.scss';

class CalculateForm extends Component {
  render() {
    return (
      <div className="calculate-form">
        <div className="container container_large">
          <div className="calculate-form__formula">
            Profit Per Paying User = -(CPC / CR1 / CR2) + (AVP - COGS) x Ret
          </div>
          <CalcSlider />
        </div>
      </div>
    )
  }
}

export default CalculateForm;


// WEBPACK FOOTER //
// ./src/components/CalculateForm/CalculateForm.js